<template>
  <div class="page-content">
    <section>
      <div class="content-wrap">
        <label-form
:value="form" :loading="isSubmitting" @submit="handleSubmit"
          @validation-change="handleValidationChange" />

        <!-- Package Selector -->
        <package-selector ref="packageSelector" />

        <!-- Actions -->
        <div class="form-actions-external">
          <el-button @click="handleCancel">
            ยกเลิก
          </el-button>
          <el-button :loading="isSubmitting" :disabled="!canSubmit" type="primary" @click="handleSubmit">
            บันทึก
          </el-button>
        </div>
      </div>
    </section>

    <!-- Loader -->
    <div v-loading.fullscreen.lock="isSubmitting" element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>

    <!-- Save Confirmation Alert -->
    <alert-dialog
:visible="confirm.open" :title="confirm.title" :message="confirm.message" confirm-text="บันทึก"
      @confirm="confirmSaveAction" @cancel="closeConfirm" />
  </div>
</template>

<script>
import { backendAdminClient } from '@/dependencies'
import LabelForm from '../components/LabelForm'
import PackageSelector from '../components/PackageSelector'
import AlertDialog from '../components/AlertDialog'
import { LabelRequest } from '../models/LabelRequest'
import { createLabelValidation } from '../utils/labelValidation'

export default {
  name: 'LabelCreatePage',
  components: {
    LabelForm,
    PackageSelector,
    AlertDialog
  },
  data() {
    return {
      isSubmitting: false,
      form: createLabelValidation(),
      isFormValid: false,
      confirm: {
        open: false,
        title: 'ยืนยันการบันทึก',
        message: 'ต้องการบันทึกข้อมูลใช่หรือไม่?'
      }
    }
  },
  computed: {
    canSubmit() {
      return this.isFormValid
    }
  },
  mounted() {
    this.$emit('sub-title', 'สร้าง Label')
  },
  methods: {
    handleSubmit() {
      this.confirm.open = true
    },
    closeConfirm() {
      this.confirm.open = false
    },
    async confirmSaveAction() {
      this.closeConfirm()
      try {
        this.isSubmitting = true
        const selectedPackages = this.$refs.packageSelector.getSelectedPackages()
        const request = LabelRequest.fromForm(this.form, selectedPackages)

        await backendAdminClient.subscriptions.label.create(request.toJSON())

        this.$message.success('สร้าง Label สำเร็จ')
        this.$router.push({ name: 'LabelList' })
      } catch (error) {
        this.$message.error(error?.message || 'Failed to create label')
      } finally {
        this.isSubmitting = false
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleValidationChange(isValid) {
      this.isFormValid = isValid
    }
  }
}
</script>
